/**
 * Magento CMS HTML was authored against CSS-module class names
 * (`[name]-[local]-[hash]`). css-loader v7 (Node upgrade) changed that hash,
 * so stored class names no longer match the stylesheet.
 *
 * Rewrite any `Name-local-<oldHash>` token to the current generated class.
 */
export function applyCssModuleClasses(html: string, ...moduleMaps: Array<Record<string, string | undefined>>): string {
    if (!html) return html;

    const prefixToGenerated = new Map<string, string>();
    for (const map of moduleMaps) {
        for (const generated of Object.values(map)) {
            if (typeof generated !== 'string') continue;
            const lastDash = generated.lastIndexOf('-');
            if (lastDash <= 0) continue;
            const prefix = generated.slice(0, lastDash + 1);
            if (prefix.length < 2) continue;
            prefixToGenerated.set(prefix, generated);
        }
    }

    if (prefixToGenerated.size === 0) return html;

    const prefixes = [...prefixToGenerated.keys()].sort((a, b) => b.length - a.length);

    return html.replace(/class=(["'])([^"']*)\1/g, (full, quote: string, classList: string) => {
        const next = classList
            .split(/\s+/)
            .map((cls) => {
                if (!cls) return cls;
                for (const prefix of prefixes) {
                    if (cls.startsWith(prefix) && cls.length > prefix.length) {
                        return prefixToGenerated.get(prefix) as string;
                    }
                }
                return cls;
            })
            .join(' ');
        return `class=${quote}${next}${quote}`;
    });
}
